import { resolveApiUrl } from '../../api';
import { useApplication } from '../ApplicationState';
export default function Sidebar() {
  const {
    authUser,
    logout,
    isAdmin,
    setViewMode,
    setSelectedPersonId,
    setShowProfile,
    setShowUserMgmt,
    bestPathway,
    showSidebar,
    setShowSidebar,
    setShowCalendar,
    openNutrition,
    openHealth,
  } = useApplication();
  const avatarUrl = authUser?.avatar ? resolveApiUrl(authUser.avatar) : '';
  const mbtiType = authUser?.mbti_type?.toUpperCase() || '';
  return (
    <>
      {/* ===== 侧边栏抽屉 ===== */}
      {showSidebar && (
        <div className="sidebar-overlay" onClick={() => setShowSidebar(false)}>
          <div className="sidebar-drawer" onClick={(e) => e.stopPropagation()}>
            {/* 侧边栏头部 - 用户信息 */}
            <div className="sidebar-header">
              <div className="sidebar-avatar">
                {avatarUrl ? (
                  <img className="sidebar-avatar-img" src={avatarUrl} alt="用户头像" />
                ) : mbtiType ? (
                  <span>{mbtiType.slice(0, 4)}</span>
                ) : (
                  <span>
                    {(authUser?.nickname || authUser?.username || 'U').charAt(0).toUpperCase()}
                  </span>
                )}
              </div>
              <div className="sidebar-user-info">
                <div className="sidebar-user-name">{authUser?.nickname || authUser?.username}</div>
                <div className="sidebar-user-sub">@{authUser?.username}</div>
                {bestPathway && (
                  <div className="sidebar-user-level">
                    {bestPathway.icon} {bestPathway.name.replace(/.*·\s*/, '')} ·{' '}
                    {bestPathway.levelName}
                  </div>
                )}
              </div>
              <button className="sidebar-close-btn" onClick={() => setShowSidebar(false)}>
                ✕
              </button>
            </div>

            {/* 侧边栏导航项 */}
            <div className="sidebar-nav">
              <div className="sidebar-nav-section">
                <div className="sidebar-section-title">六维</div>
                <button
                  className="sidebar-nav-item"
                  onClick={() => {
                    setShowSidebar(false);
                    setViewMode('wellness');
                  }}
                >
                  <span className="sidebar-nav-icon">💪</span>
                  <span className="sidebar-nav-text">身 · 身体管理</span>
                </button>
                <button
                  className="sidebar-nav-item"
                  onClick={() => {
                    setShowSidebar(false);
                    setViewMode('mind');
                  }}
                >
                  <span className="sidebar-nav-icon">🫀</span>
                  <span className="sidebar-nav-text">心 · 情绪韧性</span>
                </button>
                <button
                  className="sidebar-nav-item"
                  onClick={() => {
                    setShowSidebar(false);
                    setViewMode('intellect');
                  }}
                >
                  <span className="sidebar-nav-icon">📚</span>
                  <span className="sidebar-nav-text">智 · 知识学习</span>
                </button>
                <button
                  className="sidebar-nav-item"
                  onClick={() => {
                    setShowSidebar(false);
                    setViewMode('pathway');
                  }}
                >
                  <span className="sidebar-nav-icon">⚔️</span>
                  <span className="sidebar-nav-text">技 · 神之途径</span>
                </button>
                <button
                  className="sidebar-nav-item"
                  onClick={() => {
                    setShowSidebar(false);
                    setViewMode('people');
                    setSelectedPersonId(null);
                  }}
                >
                  <span className="sidebar-nav-icon">🤝</span>
                  <span className="sidebar-nav-text">缘 · 人际关系</span>
                </button>
                <button
                  className="sidebar-nav-item"
                  onClick={() => {
                    setShowSidebar(false);
                    setViewMode('goals');
                  }}
                >
                  <span className="sidebar-nav-icon">🎯</span>
                  <span className="sidebar-nav-text">志 · 人生方向</span>
                </button>
              </div>

              <div className="sidebar-nav-section">
                <div className="sidebar-section-title">成长</div>
                <button
                  className="sidebar-nav-item"
                  onClick={() => {
                    setShowSidebar(false);
                    setShowCalendar(true);
                  }}
                >
                  <span className="sidebar-nav-icon">📅</span>
                  <span className="sidebar-nav-text">日历</span>
                </button>
                <button
                  className="sidebar-nav-item"
                  onClick={() => {
                    setShowSidebar(false);
                    setViewMode('gamification');
                  }}
                >
                  <span className="sidebar-nav-icon">🏆</span>
                  <span className="sidebar-nav-text">成长成就</span>
                </button>
                <button
                  className="sidebar-nav-item"
                  onClick={() => {
                    setShowSidebar(false);
                    setViewMode('missions');
                  }}
                >
                  <span className="sidebar-nav-icon">📋</span>
                  <span className="sidebar-nav-text">任务中心</span>
                </button>
                <button
                  className="sidebar-nav-item"
                  onClick={() => {
                    setShowSidebar(false);
                    setViewMode('fitness');
                  }}
                >
                  <span className="sidebar-nav-icon">✅</span>
                  <span className="sidebar-nav-text">运动与训练</span>
                </button>
              </div>

              <div className="sidebar-nav-section">
                <div className="sidebar-section-title">管理</div>
                <button
                  className="sidebar-nav-item"
                  onClick={() => {
                    setShowSidebar(false);
                    openNutrition();
                  }}
                >
                  <span className="sidebar-nav-icon">🥗</span>
                  <span className="sidebar-nav-text">营养管理</span>
                </button>
                <button
                  className="sidebar-nav-item"
                  onClick={() => {
                    setShowSidebar(false);
                    openHealth();
                  }}
                >
                  <span className="sidebar-nav-icon">🏥</span>
                  <span className="sidebar-nav-text">健康管理</span>
                </button>
              </div>

              <div className="sidebar-nav-section">
                <div className="sidebar-section-title">账户</div>
                <button
                  className="sidebar-nav-item"
                  onClick={() => {
                    setShowSidebar(false);
                    setShowProfile(true);
                  }}
                >
                  <span className="sidebar-nav-icon">👤</span>
                  <span className="sidebar-nav-text">个人信息</span>
                </button>
                <button
                  className="sidebar-nav-item"
                  onClick={() => {
                    setShowSidebar(false);
                    setViewMode('settings');
                  }}
                >
                  <span className="sidebar-nav-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <circle cx="12" cy="12" r="3" />
                      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9c.26.604.852.997 1.51 1H21a2 2 0 0 1 0 4h-.09c-.658.003-1.25.396-1.51 1z" />
                    </svg>
                  </span>
                  <span className="sidebar-nav-text">设置</span>
                </button>
                {isAdmin && (
                  <button
                    className="sidebar-nav-item"
                    onClick={() => {
                      setShowSidebar(false);
                      setShowUserMgmt(true);
                    }}
                  >
                    <span className="sidebar-nav-icon">🛡️</span>
                    <span className="sidebar-nav-text">用户管理</span>
                  </button>
                )}
              </div>
            </div>

            {/* 侧边栏底部 - 退出登录 */}
            <div className="sidebar-footer">
              <button
                className="sidebar-nav-item sidebar-logout"
                onClick={() => {
                  setShowSidebar(false);
                  logout();
                }}
              >
                <span className="sidebar-nav-icon">🚪</span>
                <span className="sidebar-nav-text">退出登录</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
